module.exports = function getResource(label) {
    const resources = { reviews: 'commentaires' };
    return resources[label];
};
